import { useMonitor } from '../use-monitor';

export function useMonitorIssueTemplatesListLoad() {
  return useMonitor('issue-templates-list-load');
}
